Vendd.Scripts.load(function () {

    var $wrapper = $('.x-cookie-acceptance');

    if ($wrapper.length < 1 || LhApp.Context.IsConsentsEnabled)
        return;

    if (Cookies.get('cookiesAcceptance'))
        return;

    $wrapper.addClass('visible');

    $wrapper.on('click', '.js-accept', function (e) {
        e.preventDefault();
        Cookies.set('cookiesAcceptance', 'true', { expires: 30, samesite: 'Lax' });
        $wrapper.removeClass('visible');
    });

});